import OpenInNewIcon from "@mui/icons-material/OpenInNewRounded";
import type { SxProps, Theme, TypographyProps } from "@mui/material";
import { Button, Link, Tooltip, Typography } from "@mui/material";

interface Props {
  href: string;
  title: string;
  color: "primary" | "secondary";
  textColor?: TypographyProps["color"];
  openInNewTab?: boolean;
  buttonSx?: SxProps<Theme>;
}

const NavigateByLink = ({ href, title, color, textColor, openInNewTab, buttonSx }: Props) => {
  return (
    <Tooltip arrow title={openInNewTab ? "Open in new browser tab" : "Click to navigate"} placement="bottom">
      <Button
        variant="text"
        color={color}
        component={Link}
        href={href}
        target={openInNewTab ? "_blank" : undefined}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        sx={{ textTransform: "none", ...buttonSx }}
        endIcon={<OpenInNewIcon color="secondary" />}
      >
        <Typography color={textColor} variant="subtitle2">
          {title}
        </Typography>
      </Button>
    </Tooltip>
  );
};

export default NavigateByLink;
